import { render } from "./DepartmentManagement.vue?vue&type=template&id=a19c2ad8&scoped=true"
import script from "./DepartmentManagement.vue?vue&type=script&lang=js"
export * from "./DepartmentManagement.vue?vue&type=script&lang=js"

import "./DepartmentManagement.vue?vue&type=style&index=0&id=a19c2ad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19c2ad8"]])

export default __exports__